// Imports
// ------
import { observable } from 'mobx';

// Exports
export const lightDarkMode = observable({
	mode: `light`,
	isDark: false
});
